// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.layout--full-page[data-v-35be037f] {\n  min-height: 100vh;\n  width: 100vw;\n  background: rgb(63,162,249);\n  background: linear-gradient(164deg, rgba(63,162,249,1) 23%, rgba(59,125,196,1) 62%, rgba(28,93,193,1) 79%);\n}\n", ""]);
// Exports
module.exports = exports;
